import React from "react";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

// Segmented toggle between the schedule display and the availability display
function EditTeamButton2(props) {
  const options = [
    { key: "schedule", label: "Schedule", Icon: CalendarTodayOutlinedIcon, active: !props.editTeam },
    { key: "availability", label: "Availability", Icon: AccessTimeOutlinedIcon, active: props.editTeam },
  ];

  return (
    <div className="w-full">
      {!props.isHeaderCollapsed && (
        <div className="text-[15px] leading-6 font-semibold text-slate-900 mb-1">
          Mode
        </div>
      )}
      <div
        className="w-full flex gap-0.5 rounded-lg bg-slate-100 p-[3px]"
        role="tablist"
        aria-label="Mode"
      >
        {options.map(({ key, label, Icon, active }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => {
              if (!active) props.toggleEditTeam();
            }}
            className={`flex-1 flex items-center justify-center gap-1.5 rounded-md py-1 text-xxs font-semibold transition-colors duration-150 ${
              active
                ? "bg-white text-violet-700 shadow-sm"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <Icon style={{ fontSize: "13px" }} />
            {label}
          </button>
        ))}
      </div>

    </div>
  );
}

export default EditTeamButton2;
